import React, {useState, useEffect} from 'react'
import {firebaseAnalytics} from '../../services/firebase'
import {Helmet} from 'react-helmet'
import { connect } from 'react-redux'
import Search from './Search'
import './Trade.css'
import AllTrades from './AllTrades'
import FullLeague from './FullLeague'
import FullList from './FullList'
import {Link, Route, useHistory} from 'react-router-dom'
import { getTeamsValue } from '../Portfolio3/Functions'
import logo from '../assets/Logo1.png'

export const buttonStyle = {
    border: '1px solid gray',
    outline: 'none',
    borderRadius: '.5em',
    width: '30%',
    marginLeft: '1.5%',
    marginRight: '1.5%',
    backgroundColor: 'white',
    marginTop: '5px',
    marginBottom: '5px',
    fontSize: '1.1em',
    color: 'gray'
}
export const selectedButtonStyle = {
    border: '3px solid #c5b358',
    outline: 'none',
    borderRadius: '.5em',
    width: '30%',
    marginLeft: '1.5%',
    marginRight: '1.5%',
    backgroundColor: 'white',
    marginTop: '5px',
    marginBottom: '5px',
    fontSize: '1.1em',
    color: 'black'
}

const Trade = (props) => {
    //get props
    const user = props.user
    const teams = props.teams

    const history = useHistory()
    useEffect(()=>{
        if(display !== 'movers' && history.location.pathname === '/Trade/Movers'){
            setDisplay('movers')
        }else if(display !== 'trades' && history.location.pathname === '/Trade/Trades'){
            setDisplay('trades')
        }else if(display !== 'teams' && history.location.pathname === '/Trade/Teams'){
            setDisplay('teams')
        }
        else if(history.location.pathname === '/' || history.location.pathname === '/login'){
            history.push('/Trade/Trades')
        }
        else if(history.location.pathname === '/Trade'){
            history.push('/Trade/Trades')
        }
    },[])
    
    useEffect(()=>{
        firebaseAnalytics.logEvent("trade_visit", {
           user: user && user.email 
        })
        window.scrollTo(0,0)
    },[])

    const [display, setDisplay] = useState('trades')

    const [searchTeam, setSearchTeam] = useState('')
    const teamSearch = (val) => {
        if(val === '' || !val){
            setSearchTeam('')
        }
        setSearchTeam(val)
    }

    const [isMobile, setMobile] = useState(window.innerWidth < 768);
    const updateMedia = () => {
        setMobile(window.innerWidth < 768);
    };
    useEffect(() => {
        window.addEventListener("resize", updateMedia);
        return () => window.removeEventListener("resize", updateMedia);
    });

    return(
        <div style={{backgroundColor: 'black', minHeight: '100vh'}}>
            <Helmet>
                <title>Trade | SimBull - Buy Teams Like Stocks</title>
            </Helmet>

            {/* Search Bar 
            {display !== 'trades' && <Search teamSearch={teamSearch} />}*/}

            <div>
                {isMobile ? 
                    <div style={{height: '6vh', backgroundColor: 'black', }}>
                        <div style={{display: 'inline-block', width: '25%', height: '6vh'}}><img src={logo} style={{height: '90%', marginTop: '-2vh', marginBottom: '0%', marginLeft: '4px'}} /></div>
                        <div style={{display: 'inline-block', width: '50%', height: '6vh', color: 'white', textAlign: 'center', fontSize: '1.5rem', paddingTop: '2vh', fontWeight: '500'}}>
                            <span style={{}}>Trade</span>
                        </div>
                    </div>
                : null}

                {/* <div className='DesktopContainer' style={{textAlign: 'center'}}>
                    <Link to="/Trade/Movers"><button style={display === 'movers' ? selectedButtonStyle : buttonStyle} onClick={()=>setDisplay('movers')}>Movers</button></Link>
                    <Link to="/Trade/Trades"><button style={display === 'trades' ? selectedButtonStyle : buttonStyle} onClick={()=>setDisplay('trades')}>Trades</button></Link>
                    <Link to="/Trade/Teams"><button style={display === 'teams' ? selectedButtonStyle : buttonStyle} onClick={()=>setDisplay('teams')}>Teams</button></Link>
                </div>*/}

                <Search teamSearch={teamSearch} />

                {searchTeam === '' && <FullLeague searchTeam={searchTeam} />}

            </div>

            
            
            
        </div>
    )
}

const mapStateToProps = (state) => ({
    user: state.user.user,
    teams: state.teams.teams.teams
});

export default connect(mapStateToProps)(Trade)